import styled from "styled-components"
import { PinIcon } from "@100mslive/react-icons"
import { VariableSizeList } from "react-window"

import { maxWidth } from "utils"

import { Box } from "../shared/box"
import { Text, Title } from "../shared/text"
import Flex from "../shared/flex"

export const Chat = styled(Box)`
  height: 100%;
  overflow: overlay;

  &::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.webinar.chatScrollbar};
    border-radius: 1rem;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.webinar.chatScrollbarHover};
  }
`

export const EmptyContainer = styled(Flex)`
  width: 100%;
  height: 100%;
`

export const Promotion = styled.div`
  background-color: ${(props) => props.background};
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.8rem;
  padding: 1.5rem 1rem;
  margin-bottom: 1.6rem;
`

export const PromotionText = styled.div`
  flex-basis: 54%;
  & > p {
    font-weight: 500;
    margin: 0;
  }
`

export const PromotionButton = styled.a`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  color: #000;
  font-weight: 500;
  padding: 1rem 1.6rem;
  border-radius: 1.6rem;
  & > p {
    margin: 0;
    font-weight: 500;
    font-size: 1.3rem;
  }
`

export const PromotionButtonWrapper = styled.div`
  flex-basis: 46%;
`

export const TextArea = styled.textarea`
  width: 100%;
  height: 4.2rem;
  position: relative;
  top: ${({ hasText }) => (hasText ? "0" : "1.2rem")};
  background: transparent;
  resize: none;
  border: none;
  font-family: inherit;
  margin: 0;
  color: #191b23;
  line-height: 2rem;
  font-size: 1.7rem;

  &:focus {
    box-shadow: none;
    outline: none;
    cursor: unset;
  }

  &::-webkit-scrollbar {
    width: 0.4rem;
    height: 0.4rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.webinar.chatScrollbar};
    border-radius: 1rem;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.webinar.chatScrollbarHover};
  }
`

export const EmojiContainer = styled.div`
  position: absolute;
  bottom: 100%;
  right: 50%;
  padding: 0.8rem 0;
  transform: translate(12%, 0%);
  border-radius: 0.8rem;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  z-index: 2;
  ${(props) => props.css}
`

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.webinar.chatInputBackground};
  min-height: ${({ hasText }) => (hasText ? "8rem" : "4rem")};
  max-height: 8rem;
  position: relative;
  border-radius: 0.5rem;
  box-shadow: ${({ isFocused, theme }) =>
    isFocused && `0 0 0 3px ${theme.colors.webinar.chatInputFocus}`};
  padding: 0.75rem 0.5rem 0.75rem 1rem;
  margin-top: 1rem;
  transition: all 0.2s ease;
`

export const TextAreaContainer = styled.div`
  flex: 1;
`

export const ChatTitle = styled(Title)`
  font-family: "Abril Display", serif;
  font-size: 2.8rem;

  ${maxWidth.mobile`
    font-size: 2.2rem;
  `}
`

export const ChatHeaderWrapper = styled.div`
  color: ${(props) => props.theme.colors.webinar.chatHeading};
  height: 3rem;
  margin-bottom: 2rem;

  display: flex;
  justify-content: center;
  align-items: center;

  ${maxWidth.hamburgerLarge`
    padding: 0.5rem;
    justify-content: space-between;
  `}
`
export const ChatClose = styled.div`
  display: none;

  ${maxWidth.hamburgerLarge`
    display: block;
  `}
`

export const CircleDivider = styled.div`
  width: 0.3rem;
  height: 0.3rem;
  margin-left: 0.6rem;
  border-radius: 100%;
  background-color: #0000006c;
`

export const TextMessage = styled(Text)`
  width: 100%;
  margin-top: 0;
  color: ${(props) => props.theme.colors.webinar.chatTextMessage};
  font-size: 1.5rem;
  font-weight: 400;
  display: flex;
  justify-content: flex-start;
  line-height: 1.8rem;
  letter-spacing: 0.25px;
  word-break: break-word;
  white-space: pre-wrap;
  user-select: all;
  margin-bottom: 2rem;

  ${maxWidth.mobile`
    font-size: 1.3rem;
  `}
`

export const SenderName = styled("h5")`
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.webinar.chatSenderName};
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: pre-wrap;
  max-width: 26ch;
  min-width: 0;
  cursor: unset;

  ${maxWidth.mobile`
    font-size: 1.3rem;
  `}
`

export const ChatHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`

export const PinnedMessageContainer = styled("div")`
  padding: 1rem;
  background-color: #e7e7f2;
  border-radius: 0.8rem;
  margin-bottom: 1rem;
`

export const PinnedMessageText = styled(Text)`
  margin: 0.5rem;

  ${maxWidth.tablet`
    margin: 0;
  `}
`

export const PinnedIcon = styled(PinIcon)`
  height: 2rem;
  transform: rotate(-20deg);
`

export const ChatContainer = styled(Box)`
  position: relative;
  height: 100%;
`

export const StyledVariableSizeList = styled(VariableSizeList)`
  &::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.webinar.chatScrollbar};
    border-radius: 1rem;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.webinar.chatScrollbarHover};
  }
`

export const Link = styled.a`
  word-break: break-word;
  text-decoration: underline;
  color: #2f80e1;
`

export const ChatListContainer = styled.div`
  overflow: hidden;
`
